import React from "react";
import ReactECharts from 'echarts-for-react';
import _ from "lodash";
import PropTypes from 'prop-types';

const NestedPiesChart = (props) => {
  const {
  ActualData,
  events,
  legendData,
  legendhover,
  legendhoverOffset,
  legendIconColor,
  legendleft,
  legendSelection,
  onLegendSelectChanged,
  onSprintClick,
  percentages,
  PlannedData,
  radiusPercentage,
  sprintTitle,
  toolTipConfig,
} = props;

 const getNestOption = () => {

       const options = {
        tooltip: toolTipConfig ? { ...toolTipConfig } : {
          show: true,
          trigger: 'item',

      },
        title: [
            {
              show: true,
              text: `${sprintTitle}`,
              x: "center",
              y: 30,
              textStyle: {
                fontSize: 15,
              }
          },
          {
              show: true,
              text: ` ${percentages}`,
              x: "center",
              y: "center",
              textStyle: {
                fontSize: 15,
              }
          }
        ],
         legend: {
           icon:'circle',
           orient: "horizontal",
           left: legendleft?legendleft:"left",
           right: 10,
           selected: legendSelection,  
           show:false,// pass it as props will imapct flow predicatability
           data: legendData,
           itemStyle: {
            width: 15, 
            height: 15,  
          },
         },
         grid: {
          left: '200%',
          right: '20%',
          top: '20%',
          bottom: '20%'
      },
        
         series: [
          {
            name: legendData[1],
            hoverAnimation: legendhover===false?false:true,
            hoverOffset: legendhoverOffset===true?0:undefined,  
            hoverLink: legendhover===false?false:true,
            type: 'pie',
            color:legendIconColor.Actual,
            selectedMode: 'single',
            radius: [0, `${radiusPercentage.percentageActual}%`],

            label: {
              show:false,
              position: 'inner',
              fontSize: 14
            },
            labelLine: {
              show: false
            },
    
            data: ActualData?ActualData:[],
            iconSize: [15, 26],
          },
          
          {
            name: legendData[0],
            color: '#8C8D8E',  
            type: 'pie',
            hoverAnimation: legendhover===false?false:true,
            hoverOffset: legendhoverOffset===true?0:undefined,  
            hoverLink: legendhover===false?false:true,
            radius: [`${radiusPercentage.percentagePlanned}%`, `${radiusPercentage.percentagePlanned}%`],
            iconSize: [15, 26],
            labelLine: {
              length: 30
            },
            label: {
              show: false,
              formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
              backgroundColor: '#F6F8FC',
              borderColor: '#8C8D8E',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                a: {
                  color: '#6E7079',
                  lineHeight: 22,
                  align: 'center'
                },
                hr: {
                  borderColor: '#8C8D8E',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                b: {
                  color: '#4C5058',
                  fontSize: 14,
                  fontWeight: 'bold',
                  lineHeight: 33
                },
                per: {
                  color: '#fff',
                  backgroundColor: '#4C5058',
                  padding: [3, 4],
                  borderRadius: 4
                }
              }
            },
            itemStyle: {
              normal: {
                 borderWidth: 5,
                borderColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#8C8D8E' },
                    { offset: 1, color: '#8C8D8E' },
                  ],
                  globalCoord: false,
                },
                borderType: 'dashed',
                borderDash: [300, 25], 
      
              },
            },
            data: PlannedData?PlannedData:[],
          }
        ]
      };   
         return options;
    };

    const handleChartClick = (params) => {
      const clickedIndex = params.dataIndex;
      const clickedSprint = sprintTitle[clickedIndex];
      if (onSprintClick) {
        onSprintClick(clickedSprint, sprintTitle);
      }
    };
    
      const handleLegendSelectChanged = (params,titleName) => {
        if (onLegendSelectChanged) {

          onLegendSelectChanged(params.selected);
        }
    };
    
      const onEvents = {
        'click': handleChartClick,
        'legendselectchanged': handleLegendSelectChanged,
      };
    
  return (
    <div>
      <ReactECharts 
         option={getNestOption()} 
         onEvents={events ? onEvents : ""}
  
         />
    </div>
  );
};

function areEqual(prevProps, nextProps) {
  if(_.isEqual(prevProps.ActualData, nextProps.ActualData) &&
  _.isEqual(prevProps.PlannedData, nextProps.PlannedData) &&
  _.isEqual(prevProps.percentages, nextProps.percentages) &&
  _.isEqual(prevProps.radiusPercentage, nextProps.radiusPercentage) && 
  _.isEqual(prevProps.legendhoverOffset, nextProps.legendhoverOffset)) {
    return true;
  } else {
    return false;
  }
}

NestedPiesChart.propTypes = {
  ActualData: PropTypes.array,
  PlannedData: PropTypes.array,
  color: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  data: PropTypes.any,
  events: PropTypes.bool,
  howTitle: PropTypes.string,
  legendColor: PropTypes.any,
  legendData: PropTypes.array,
  legendhover: PropTypes.bool,
  legendhoverOffset: PropTypes.bool,
  legendIconColor: PropTypes.shape({
    Actual: PropTypes.string,
    Planned: PropTypes.string
  }),
  legendleft: PropTypes.string,
  legendSelection: PropTypes.object,
  legendshow: PropTypes.bool,
  onLegendSelectChanged: PropTypes.func,
  onSprintClick: PropTypes.func,
  percentages: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  radiusPercentage: PropTypes.shape({
    percentageActual: PropTypes.number,
    percentagePlanned: PropTypes.number
  }),
  selectedMode: PropTypes.string,
  showSubTitle: PropTypes.bool,
  showTitle: PropTypes.bool,
  sprintNames: PropTypes.array,
  sprintTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  titleName: PropTypes.string,
  toolTipConfig: PropTypes.object,
};

export default React.memo(NestedPiesChart, areEqual);


